// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IBeu0","colMin":"styles_colMin__1pYsF"};